import React, {useState, useEffect} from "react";

export default function ParkaPrimoInnenjackeFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M288.775,381.16c-4.013-0.054-9.381-0.065-14.116-0.075c-9.723-0.019-20.742-0.04-22.62-0.367
     c-0.974-0.172-1.938-0.327-2.876-0.453c-0.687-0.087-1.484-0.179-2.346-0.179c-0.27,0-0.545,0.009-0.825,0.029
     c-1.129,0.082-2.259,0.219-3.356,0.406c-0.793,0.129-3.463,0.195-7.93,0.195c-4.048,0-9.089-0.05-14.426-0.104l-1.442-0.014
     c-4.529-0.044-9.098-0.089-12.676-0.089c-11.81,0-50.656-10.421-52.721-11.561c-1.578-1.025-1.799-1.468-1.799-3.632
     c0-8.891-0.646-15.813-1.817-19.49c-1.559-4.89-1.894-10.399-2.218-15.728c-0.063-1.127-0.126-2.179-0.201-3.209
     c-0.461-6.656-0.618-13.39-0.466-20.009c0.181-8.014,1.078-16.013,1.944-23.749l0.148-1.35c0.384-3.5,0.781-7.119,1.097-10.688
     c0.514-5.807,1.004-11.718,1.479-17.45l0.063-0.752c0.539-6.586,1.17-14.226,1.836-21.563c0.715-7.857-0.075-15.794-1.021-23.911
     l-0.445-3.815l-1.608,3.883l-0.141,0.358c-0.167,0.423-0.324,0.825-0.455,1.217c-0.538,1.648-1.032,3.307-1.51,4.915l-0.03,0.102
     c-1.073,3.608-2.182,7.339-3.789,10.951c-2.225,4.986-4.868,9.818-7.853,14.362c-3.579,5.451-7.792,10.759-11.51,15.44
     c-1.95,2.458-3.967,5-5.905,7.567c-1.188,1.559-2.352,3.219-3.478,4.825l-0.524,0.747c-2.406,3.425-4.894,6.966-7.71,9.967
     c-2.291,2.442-4.793,4.838-7.214,7.154c0,0-0.784,0.748-1.13,1.08l-0.848-0.889l-0.892,2.34c-0.734,0.771-2.116,2.398-4.902,5.986
     c-0.38,0.493-0.655,0.842-0.747,0.954c-3.149,3.705-5.903,7.692-8.408,12.178c-2.979,5.337-5.817,10.804-8.436,16.249
     c-1.404,2.908-2.645,5.591-3.792,8.2c-0.105,0.251-0.214,0.5-0.323,0.75c-0.785,1.824-1.671,3.885-3.02,5.229
     c-0.546,0.552-0.948,1.049-1.38,1.597c-1.207,1.509-1.934,2.418-5.228,2.418c-3.319,0-5.632-0.475-6.716-0.758l-0.8-0.209
     l-0.355,0.747c-1.223,2.569-5.115,11.3-3.896,15.757c0.073,0.274,0.015,0.482-0.192,0.673c-0.208,0.194-1.149,0.818-4.601,0.818
     c-5.417,0-14.116-1.565-19.805-3.564c-4.711-1.663-5.478-2.906-5.577-3.398c0.63-7.267,1.915-15.412,3.372-17.27l0.314-0.399
     l-0.138-0.489c-0.407-1.443-1.057-2.825-1.631-4.044l-0.042-0.089c-0.617-1.32-1.256-2.686-1.59-4.069
     c-0.25-1.015-0.079-2.111,0.143-3.146c0.874-3.912,2.609-7.751,4.14-11.138c0.939-2.093,1.898-4.231,2.693-6.374
     c2.521-6.81,4.542-12.542,6.212-18.388c3.409-11.924,8.777-23.407,13.969-34.513c1.023-2.185,2.011-4.311,2.995-6.437
     c6.462-14.034,13.845-30.625,19.61-47.279c4.064-11.738,20.794-46.74,28.301-57.07c7.475-10.271,17.402-26.104,21.077-34.821
     c3.506-8.336,13.595-19.418,15.674-21.177l0.354-0.299v-2.349c0.618-1.294,2.247-1.936,3.563-2.453
     c0.336-0.13,0.656-0.255,0.946-0.381c2.084-0.925,4.182-1.899,6.21-2.841c1.933-0.901,3.885-1.812,5.827-2.675
     c8.378-3.712,17.062-7.257,25.807-10.538c6.479-2.418,12.929-4.67,19.168-6.692c0.816-0.269,1.659-0.52,2.476-0.755
     c2.049-0.6,4.367-1.278,6.351-2.325c1.933-1.017,3.777-2.299,5.405-3.43l1.077-0.737l-0.021-0.551
     c-0.366-9.557,1.513-15.257,3.19-19.156c0.16-0.378,0.325-0.752,0.49-1.125l0.241-0.547c0.834-1.877,1.699-3.824,2.249-5.86
     c0.076-0.302,0.142-0.594,0.208-0.89c0.141-0.642,0.257-1.174,0.469-1.673c0.172-0.405,0.373-0.721,0.612-0.965
     c0.403-0.331,0.72-0.498,0.87-0.54l1.493-0.422l-0.234-0.277c1.471-0.766,3.091-1.496,5.005-2.256
     c4.079-1.634,7.601-2.628,11.086-3.131c3.97-0.583,8.028-0.682,11.474-0.701c0.583-0.003,1.171-0.005,1.767-0.005
     c6.805,0,14.738,0.295,21.972,2.49c4.282,1.298,8.182,2.955,11.601,4.928v0.027l0.529,0.287c1.037,0.553,1.46,1.446,1.806,2.708
     c0.852,3.152,2.052,6.225,3.208,9.101c1.582,3.942,3.317,9.686,2.692,19.187l-0.036,0.555l1.068,0.765
     c1.735,1.261,3.491,2.537,5.34,3.561c1.978,1.101,4.28,1.828,6.312,2.47l0.363,0.117c0.7,0.225,1.416,0.455,2.104,0.696
     c6.337,2.229,12.75,4.639,19.06,7.16c8.613,3.453,17.212,7.196,25.557,11.126c1.156,0.543,2.304,1.104,3.444,1.661l0.795,0.388
     l0.055,0.031l1.472,0.724c1.993,0.986,4.058,2.008,6.124,2.972c0.287,0.135,0.598,0.266,0.924,0.403
     c1.399,0.59,2.95,1.245,3.504,2.499l-0.06,2.37l0.351,0.309c1.954,1.725,11.854,13.16,15.091,21.417
     c3.374,8.601,13.061,24.905,20.1,35.079c7.207,10.414,22.939,45.507,26.672,57.241c5.32,16.716,12.21,33.276,18.247,47.27
     c0.914,2.125,1.845,4.251,2.78,6.383c4.869,11.114,9.903,22.607,12.978,34.512c1.507,5.833,3.359,11.541,5.678,18.317
     c0.713,2.084,1.588,4.169,2.434,6.185l0.07,0.167c1.51,3.592,3.063,7.286,3.813,11.108c0.191,1.025,0.332,2.119,0.06,3.113
     c-0.365,1.354-1.024,2.684-1.661,3.971l-0.065,0.131c-0.644,1.294-1.292,2.596-1.722,3.978l-0.151,0.486l0.305,0.408
     c1.207,1.619,2.341,8.339,2.891,17.131c-0.268,1.063-2.464,2.302-6.066,3.469c-5.583,1.804-13.694,3.164-18.867,3.164
     c-3.753,0-4.756-0.693-4.974-0.905c-0.195-0.191-0.247-0.396-0.166-0.66c1.277-4.257-1.989-12.385-3.453-15.682l-0.34-0.767
     l-0.814,0.201c-0.804,0.199-3.02,0.661-6.224,0.661l-0.478-0.005c-3.263-0.042-3.96-0.956-5.116-2.47
     c-0.367-0.488-0.776-1.021-1.333-1.6c-1.304-1.358-2.13-3.415-2.859-5.23l-0.307-0.755c-1.057-2.57-2.219-5.249-3.555-8.197
     c-2.456-5.425-5.139-10.897-7.973-16.265c-2.367-4.483-5.006-8.488-8.065-12.244c-0.095-0.115-0.349-0.457-0.704-0.938
     c-2.639-3.56-3.99-5.219-4.728-6.021l-0.836-2.362l-0.873,0.873l-1.205-1.199c-2.313-2.307-4.707-4.692-6.894-7.114
     c-2.768-3.07-5.179-6.678-7.51-10.166l-0.16-0.239c-1.17-1.746-2.379-3.552-3.609-5.25c-1.799-2.489-3.642-4.923-5.69-7.618
     c-3.6-4.739-7.681-10.111-11.098-15.568c-2.861-4.566-5.375-9.427-7.472-14.445c-1.528-3.663-2.536-7.386-3.511-10.986
     c-0.443-1.634-0.901-3.321-1.403-4.998c-0.151-0.501-0.344-1.021-0.555-1.576c-0.034-0.103-0.087-0.246-0.146-0.381l-1.403-3.253
     l-0.505,3.506c-1.16,8.068-2.16,15.958-1.659,23.798c0.479,7.443,0.92,15.237,1.274,21.501l0.041,0.743
     c0.322,5.724,0.654,11.621,1.016,17.421c0.263,4.19,0.618,8.393,0.932,12.001l0.014,0.169c0.652,7.687,1.327,15.635,1.295,23.521
     c-0.021,6.563-0.355,13.268-0.994,19.927c-0.08,0.812-0.154,1.64-0.229,2.478l-0.059,0.647c-0.455,5.311-0.926,10.798-2.63,15.7
     c-1.272,3.646-2.104,10.535-2.34,19.396c-0.06,2.153-0.293,2.592-1.92,3.607c-2,1.063-40.877,10.87-52.955,10.87H288.775z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M83.5,306.345c-0.122,0.213-0.249,0.43-0.372,0.648c-2.964,5.311-5.811,10.786-8.451,16.263
     c-1.423,2.964-2.666,5.645-3.787,8.211c-0.105,0.244-0.217,0.499-0.329,0.753c-0.775,1.802-1.646,3.836-2.952,5.138
     c-0.579,0.579-1.014,1.125-1.402,1.608c-1.147,1.445-1.843,2.316-4.998,2.316c-3.07,0-5.306-0.424-6.384-0.679l-1.929,0.993
     c-1.284,2.75-4.949,11.18-3.744,15.595c0.042,0.17,0.015,0.265-0.106,0.382c-1.944,1.805-15.456,0.228-24.103-2.81
     c-3.714-1.306-5.206-2.465-5.376-3.139c0.526-6.049,1.912-15.987,3.41-17.188l0.032-1.349c-0.409-1.317-0.989-2.56-1.557-3.77
     c-0.658-1.398-1.274-2.714-1.615-4.1c-0.239-0.978-0.068-2.024,0.149-3.008c0.844-3.829,2.512-7.514,4.117-11.094
     c0.934-2.077,1.901-4.228,2.703-6.384c2.285-6.167,4.159-11.462,5.748-16.795C38.178,290.171,75.337,304.9,83.5,306.345"
        />
        <polygon
          fill="#010101"
          points="25.938,333.938 34.875,336.625 43.375,339 48.813,340.438 54,341.313 52.438,344.625 
     50.438,349.875 49.75,353 49.313,355.688 49.938,357.938 47.813,358.75 39.969,358.75 30.5,357.188 23.063,354.875 19.567,352.688 
     18.813,351.063 19.567,346.813 20.25,340.25 21.25,336.313 22.125,334.75 23.688,333.438 	"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M474.558,332.656c-0.595,1.19-1.206,2.423-1.641,3.724l0.159,1.503c1.376,1.748,2.418,11.128,2.768,16.911
     c-0.106,0.341-0.834,1.563-5.853,3.182c-8.749,2.825-21.73,4.11-23.546,2.331c-0.112-0.111-0.137-0.201-0.084-0.366
     c1.312-4.366-2.109-12.784-3.309-15.525l-1.083-1.19c-0.059,0.01-0.112,0.016-0.164,0.027c-0.096,0.021-0.198,0.043-0.293,0.053
     c-0.122,0.027-0.238,0.053-0.362,0.09c-0.037,0.012-0.068,0.012-0.095,0.006c-1.11,0.245-3.298,0.616-6.273,0.579
     c-3.133-0.047-3.792-0.918-4.898-2.358c-0.377-0.494-0.796-1.048-1.355-1.626c-1.258-1.311-2.076-3.34-2.798-5.135
     c-0.1-0.255-0.208-0.509-0.308-0.76c-1.047-2.555-2.21-5.237-3.559-8.207c-2.481-5.475-5.168-10.957-7.977-16.278
     c-0.124-0.218-0.239-0.435-0.357-0.648c8.142-1.308,45.434-15.339,51.112-17.481c1.433,5.312,3.15,10.586,5.253,16.721
     c0.738,2.157,1.641,4.303,2.518,6.378c1.496,3.565,3.042,7.246,3.781,11.049c0.198,0.977,0.335,2.018,0.07,2.973
     C475.897,329.985,475.243,331.282,474.558,332.656"
        />
        <polygon
          fill="#010101"
          points="442.621,343.788 452.813,341.938 462.938,339.063 471.813,337.063 473.257,337.271 475.125,341.75 
     476.411,352.875 475.938,355.938 469.51,359.489 453.25,361.813 446.313,361.124 445.123,360.596 446.074,359.47 445.938,357.063 
     445.5,353.563 444.188,349.438 442.621,345.75 441.938,344 	"
        />
        <path
          fill="#010101"
          d="M214.046,253.816c-4.061-7.216-6.818-12.716-6.846-12.772l-0.383-0.763l-0.631,0.572
     c-1.533,1.381-37.647,34.025-45.828,45.837l-0.215,0.315l7.032,14.07l0.631-0.814c0.188-0.241,19.018-24.423,46.07-45.612
     l0.439-0.343L214.046,253.816z M167.418,298.665l-5.771-11.551c7.902-11.093,39.878-40.281,44.78-44.73
     c0.869,1.706,3.156,6.123,6.214,11.583C188.465,272.994,170.915,294.298,167.418,298.665"
        />
        <path
          fill="#C8C8C8"
          d="M427.831,195.172c-3.485,2.354-7.243,4.966-11.481,7.984c-2.62,1.86-5.162,3.878-7.622,5.834
     c-3.179,2.524-6.471,5.14-9.932,7.417c-6.122,4.029-13.073,7.61-21.87,11.272c-1.212,0.507-2.424,1.019-3.636,1.536
     c-4.769,2.026-9.707,4.125-14.75,5.592c-1.267-2.442-2.434-4.933-3.489-7.458c-1.504-3.612-2.474-7.178-3.494-10.956
     c-0.444-1.632-0.9-3.32-1.403-5.003c-0.005,0-0.005-0.005-0.005-0.009c4.728-1.454,9.324-3.397,13.782-5.286
     c1.207-0.512,2.414-1.025,3.626-1.527c8.88-3.686,15.904-7.304,22.105-11.373c3.511-2.304,6.826-4.933,10.033-7.477
     c2.45-1.937,4.978-3.946,7.572-5.788c3.96-2.813,7.503-5.273,10.792-7.499C421.837,180.649,425.407,188.962,427.831,195.172"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M417.506,171.238c-3.346,2.264-6.955,4.769-10.993,7.636c-2.62,1.862-5.167,3.879-7.627,5.831
     c-3.182,2.524-6.475,5.134-9.937,7.412c-6.131,4.02-13.087,7.599-21.893,11.253c-1.213,0.504-2.423,1.02-3.63,1.533
     c-4.44,1.883-9.022,3.818-13.7,5.253c-0.046-0.119-0.091-0.238-0.133-0.356c-0.374-0.993-0.759-2.021-0.855-2.941l-0.045,0.005
     c0.869-6.013,1.728-12.205,1.889-18.286c0.159-5.999,11.185-53.835,13.973-61.891c2.638-7.613,4.267-31.688,4.647-37.817
     c2.93,3.07,11.299,13.047,14.248,20.555c3.429,8.744,12.928,24.73,20.128,35.136C406.948,149.436,412.372,160.145,417.506,171.238"
        />
        <path
          fill="#C8C8C8"
          d="M246.2,199.913l-0.434,23.843c-1.138-0.034-4.06-0.129-10.764-0.449
     c-8.939-0.419-72.577,1.431-80.927,1.678c-0.027-6.428-0.787-12.889-1.527-19.195c-0.124-1.052-0.247-2.108-0.371-3.17
     c13.444-0.549,71.618-2.708,76.848-2.708H246.2z"
        />
        <path
          fill="#C8C8C8"
          d="M347.599,205.354c-0.114,0.805-0.233,1.606-0.348,2.406c-0.91,6.264-1.842,12.689-2.039,19.09
     c-8.35-0.397-72.231-3.416-81.243-3.168c-6.768,0.192-9.713,0.238-10.865,0.252l0.196-23.389
     c14.651-0.128,31.382,0.576,52.577,2.213c3.077,0.238,6.225,0.504,9.264,0.759C325.793,204.413,336.79,205.331,347.599,205.354"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M212.641,253.967c-24.176,19.028-41.726,40.331-45.223,44.698l-5.771-11.551
     c7.902-11.093,39.878-40.281,44.78-44.729C207.297,244.09,209.582,248.507,212.641,253.967"
        />
        <path
          fill="#C8C8C8"
          d="M349.877,308.925c-0.023,6.604-0.362,13.298-0.997,19.896c-0.009,0.054-0.014,0.105-0.018,0.155
     c-38.845,11.912-91.147,11.259-97.48,11.126l0.142-21.561c1.207,0.042,3.987,0.12,8.02,0.12c16.527,0,54.049-1.34,90.319-12.027
     C349.872,307.398,349.881,308.162,349.877,308.925"
        />
        <path
          fill="#C8C8C8"
          d="M244.38,318.359v21.561c-6.338,0.031-58.274-0.018-96.666-12.501c-0.005-0.051-0.005-0.1-0.009-0.151
     c-0.462-6.63-0.623-13.353-0.471-19.983c0.018-0.773,0.051-1.541,0.077-2.309c39.216,12.31,79.798,13.425,93.168,13.425
     C242.323,318.4,243.644,318.379,244.38,318.359"
        />
        <path
          fill="#C8C8C8"
          d="M149.557,209.36c0,0.006-0.005,0.01-0.005,0.01c-0.544,1.677-1.048,3.365-1.532,4.997
     c-1.125,3.774-2.187,7.336-3.786,10.929c-1.125,2.52-2.355,5.003-3.686,7.429c-5.007-1.563-9.886-3.762-14.609-5.884
     c-1.193-0.539-2.392-1.08-3.59-1.61c-8.71-3.845-15.578-7.576-21.61-11.742c-3.411-2.355-6.644-5.048-9.767-7.65
     c-2.414-2.017-4.916-4.097-7.49-6.023c-4.18-3.118-7.888-5.82-11.327-8.258c2.601-6.21,6.415-14.515,10.43-22.708
     c3.238,2.304,6.731,4.856,10.636,7.774c2.547,1.902,5.034,3.973,7.44,5.976c3.146,2.621,6.397,5.331,9.859,7.719
     c6.1,4.215,13.032,7.983,21.825,11.865c1.193,0.526,2.388,1.062,3.581,1.601C140.329,205.771,144.874,207.81,149.557,209.36"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M151.13,204.851l-0.05-0.005c-0.116,0.924-0.531,1.949-0.929,2.936c-0.046,0.124-0.091,0.243-0.142,0.362
     c-4.636-1.533-9.163-3.562-13.554-5.537c-1.193-0.539-2.391-1.08-3.59-1.61c-8.71-3.845-15.578-7.576-21.61-11.743
     c-3.411-2.355-6.643-5.048-9.767-7.65c-2.414-2.012-4.915-4.097-7.49-6.018c-3.987-2.977-7.54-5.569-10.837-7.915
     c5.45-11.058,11.18-21.725,14.696-26.559c7.495-10.302,17.44-26.169,21.108-34.88c3.145-7.48,11.783-17.308,14.802-20.326
     c0.219,6.168,1.207,30.39,3.644,38.105c2.575,8.148,12.314,56.421,12.314,62.448C149.726,192.57,150.421,198.798,151.13,204.851"
        />
        <path
          fill={darkenColor}
          d="M284.011,19.129c-0.112,1.563-0.419,3.134-0.936,4.663c-1.19,3.522-3.351,6.676-6.241,9.12
     c-2.502,2.114-5.751,3.537-10.229,4.472c-3.925,0.824-7.341,1.556-10.708,2.363l-0.67,1.497c-0.18,0.463-0.44,1.126-0.834,2.083
     c-1.513,3.696-1.258,27.13-1.243,28.141l-0.084,51.865c-0.074,2.034-1.816,49.831-1.371,57.192
     c-0.195,7.51,0.32,17.427,0.345,18.011l-0.047,2.019l0.01-0.006l-0.196,24.023c-0.064,1.712-1.327,38.62-1.026,44.197
     c-0.121,2.215-0.121,9.333-0.121,17.559c-0.012,11.733-0.016,26.329-0.394,30.1l-0.037,1.429v0.027l-0.016,0.595h0.016
     l-0.159,22.882h0.006l-0.17,39.107c-0.234-0.037-0.474-0.074-0.707-0.106c-0.929-0.121-2.039-0.239-3.224-0.149
     c-0.388,0.028-0.791,0.069-1.196,0.112l0.882-39.129h0.015v-24.873l-0.005-0.047c-0.303-4.233,0.207-21.523,0.583-34.143
     c0.187-6.442,0.335-11.524,0.335-13.363c0-5.433,0.452-43.824,0.457-44.346l0.447-24.511h0.01v-1.993
     c0.005-0.096,0.456-9.704,0.456-17.405c0-7.224,0.908-56.646,0.918-57.152l0.914-51.663c0.043-1.144,0.897-24.869-0.499-28.597
     c-0.356-0.94-0.595-1.599-0.754-2.061l-1.094-1.731c-0.064-0.022-0.122-0.038-0.181-0.059c-1.423-0.483-2.82-0.744-4.291-1.02
     l-0.456-0.09c-0.564-0.1-1.137-0.202-1.721-0.308c-2.932-0.515-5.965-1.057-8.403-2.331c-3.07-1.604-5.503-3.51-7.447-5.848
     c-1.683-2.024-2.973-4.579-3.723-7.394c-0.255-0.961-0.452-1.938-0.568-2.911c-0.022-0.18-0.031-0.366-0.043-0.546
     c-0.006-0.23-0.027-0.468-0.059-0.712c1.61-0.882,3.426-1.716,5.678-2.619c4.047-1.619,7.553-2.614,11.016-3.113
     c3.941-0.573,7.988-0.669,11.435-0.691c7.336-0.053,15.834,0.096,23.647,2.471C276.661,15.454,280.585,17.132,284.011,19.129"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M219.034,117.166c-0.32,2.607-0.682,8.692-1.079,18.094c-0.005,0.087-0.009,0.17-0.014,0.256l-9.251,5.958
     l-25.186,2.25c-0.575-0.44-2.318-1.609-7.329-4.295c-0.009-1.865-0.051-4.467-0.096-7.216c-0.079-4.765-0.179-11.129-0.037-12.807
     c1.156-0.068,4.344-0.264,10.846-0.677c9.483-0.598,22.474-1.417,31.766-1.966c0.147-0.014,0.243,0.068,0.289,0.114
     C218.984,116.924,219.052,117.021,219.034,117.166"
        />
        <path
          fill="#010101"
          d="M337.279,288.217c-7.888-11.908-43.275-45.087-44.775-46.491l-0.617-0.576l-0.398,0.74
     c-0.032,0.055-2.95,5.502-7.225,12.635l-0.288,0.484l0.434,0.351c26.622,21.607,44.871,46.016,45.05,46.257l0.612,0.824
     l7.417-13.905L337.279,288.217z M329.885,300.037c-3.389-4.404-20.436-25.927-44.223-45.329c3.228-5.406,5.648-9.781,6.567-11.464
     c4.788,4.513,36.116,34.176,43.751,45.369L329.885,300.037z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M335.98,288.614l-6.094,11.424c-3.389-4.404-20.437-25.928-44.224-45.33
     c3.228-5.405,5.648-9.78,6.568-11.463C297.017,247.757,328.345,277.421,335.98,288.614"
        />
        <path
          fill="#010101"
          d="M220.322,117.322c0.059-0.489-0.1-0.973-0.435-1.328c-0.34-0.362-0.818-0.552-1.312-0.527
     c-9.289,0.553-22.281,1.371-31.767,1.971c-6.157,0.388-11.022,0.691-11.282,0.697l-0.292,0.012l-0.186,0.196
     c-0.303,0.301-0.425,0.802-0.351,7.627c-2.002,0.148-4.02,0.249-6.012,0.323l-0.472,0.022c-0.489,0.016-0.993,0.037-1.488,0.037
     h-0.015l-0.341-0.006c-0.499-0.006-1.025-0.015-1.566,0.101c-0.797,0.165-1.334,0.877-1.345,1.765
     c-0.01,1.412,0.028,2.842,0.069,4.216c0.01,0.531,0.027,1.068,0.043,1.604c0.053,2.492,0.112,4.976,0.18,7.472
     c0.085,3.092,0.176,5.844,0.271,8.409c0.08,2.109,0.192,4.886,0.356,7.702c0.096,1.71,0.34,4.594,0.542,6.421
     c0.934,8.508,2.183,32.676,2.183,33.855l0.016,0.301l0.201,0.192c0.165,0.159,0.351,0.335,3.585,0.335
     c3.32,0,9.837-0.181,22.823-0.766c12.551-0.563,25.145-1.237,25.272-1.242l0.638-0.037l-0.022-0.633
     c-0.015-0.371-1.37-37.106-0.366-60.725C219.647,125.952,220.009,119.897,220.322,117.322 M168.388,197.386
     c-0.139-3.888-1.334-25.803-2.183-33.494c-0.202-1.805-0.435-4.658-0.531-6.359c-0.164-2.799-0.277-5.571-0.356-7.674
     c-0.096-2.56-0.186-5.306-0.266-8.393c-0.074-2.49-0.133-4.976-0.192-7.468c-0.01-0.537-0.025-1.072-0.043-1.609
     c-0.031-1.371-0.074-2.783-0.064-4.17c0-0.043,0.012-0.446,0.314-0.509c0.403-0.08,0.833-0.075,1.286-0.069
     c0.121,0,0.238,0.005,0.371,0.005c0.521,0,1.036-0.02,1.541-0.042l0.468-0.016c1.98-0.069,3.988-0.18,5.98-0.319
     c0.016,1.414,0.038,3.055,0.069,4.967c0.047,2.937,0.096,5.714,0.096,7.584v0.388l0.34,0.18c6.517,3.479,7.59,4.434,7.622,4.462
     l0.217,0.211l26.063-2.325l8.764-5.636c-0.796,21.924,0.239,53.481,0.409,58.351C199.613,196.446,172.18,197.72,168.388,197.386
      M219.032,117.167c-0.319,2.608-0.68,8.69-1.079,18.091c-0.005,0.09-0.005,0.171-0.01,0.261l-9.252,5.953l-25.186,2.252
     c-0.574-0.441-2.316-1.609-7.33-4.292c-0.01-1.869-0.049-4.472-0.096-7.218c-0.08-4.765-0.18-11.127-0.037-12.806
     c1.157-0.068,4.344-0.264,10.846-0.678c9.485-0.602,22.478-1.42,31.767-1.967c0.149-0.015,0.245,0.07,0.288,0.118
     C218.983,116.923,219.053,117.018,219.032,117.167"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M222.019,19.186c-0.013-0.102-0.02-0.202-0.025-0.301c1.363-0.706,2.896-1.394,4.749-2.135c3.957-1.582,7.359-2.545,10.706-3.031
     c3.827-0.556,7.831-0.654,11.245-0.676c0.643-0.005,1.296-0.008,1.956-0.008c6.59,0,14.272,0.288,21.286,2.418
     c3.89,1.18,7.462,2.668,10.628,4.43"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="M366.699,85.66
     l-0.044,1.699c-0.665,11.317-2.376,32.083-4.585,38.454c-2.925,8.437-13.948,56.323-14.117,62.696
     c-0.047,1.691-0.146,3.436-0.303,5.291c0,0,0.722,0.434,1.637,0.434"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M426.153,194.652c-3.305,2.244-6.783,4.669-10.6,7.387c-2.713,1.927-5.353,4.027-7.68,5.877c-3.16,2.511-6.424,5.103-9.832,7.346
     c-6.043,3.975-12.921,7.518-21.645,11.15c-1.217,0.509-2.431,1.023-3.645,1.541c-4.404,1.871-8.928,3.792-13.513,5.213"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M351.842,212.284c4.357-1.424,8.552-3.201,12.621-4.925l0.06-0.025c1.185-0.502,2.368-1.004,3.558-1.498
     c8.946-3.712,16.042-7.365,22.331-11.492c3.563-2.339,6.903-4.988,10.131-7.548l0.228-0.181c2.362-1.868,4.805-3.8,7.287-5.564
     c3.369-2.393,6.468-4.552,9.427-6.57"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M462.665,289.383c-20.12,7.597-43.028,15.734-49.07,16.877"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M148.605,307.316c0.003-0.167,0.008-0.334,0.014-0.5c38.228,11.681,76.869,12.957,91.861,12.957c1.013,0,1.86-0.007,2.528-0.015
     v18.793c-10.003-0.012-57.986-0.69-93.988-12.153"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M343.342,360.679c-10.295,2.754-46.034,11.66-54.372,11.66l-0.119-0.001c-3.999-0.051-9.213-0.065-14.211-0.074
     c-4.32-0.01-17.436-0.104-21.838-0.155"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M152.204,360.679c10.295,2.754,46.949,11.888,55.286,11.889l0.119-0.001c3.998-0.051,9.213-0.065,14.21-0.073
     c4.32-0.01,16.065,0.124,20.467,0.074"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M347.586,327.931c-32.59,9.787-74.114,10.851-90.56,10.851c-1.793,0-3.227-0.014-4.263-0.028l0.124-18.799
     c1.518,0.038,3.772,0.077,6.657,0.077c14.71,0,52.483-1.14,88.964-11.575"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M343.895,225.415c-11.268-0.534-66.446-3.119-78.619-3.119c-0.53,0-0.979,0.006-1.344,0.014c-3.939,0.112-7.16,0.192-9.443,0.231"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M254.662,201.907c0.677-0.005,1.359-0.006,2.046-0.006c13.832,0,29.423,0.706,49.065,2.224c2.994,0.232,6.058,0.49,9.023,0.739
     l0.231,0.018c10.118,0.851,20.566,1.731,30.99,1.834"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M252.99,315.916c0.325-4.77,0.33-17.912,0.334-29.583c0.005-7.888,0.009-15.338,0.126-17.452l0.002-0.188l-0.002-0.039
     c-0.265-4.619,0.707-34.622,0.955-42.069 M290.239,241.315c-0.744,1.375-3.456,6.338-7.152,12.504l-0.897,1.51l1.357,1.098
     c26.676,21.651,44.631,45.765,44.809,46.005l1.908,2.564l8.819-16.534l-0.657-1c-7.987-12.057-43.478-45.327-44.986-46.739
     l-1.921-1.792L290.239,241.315z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M244.419,222.34c-1.788-0.062-4.691-0.18-9.351-0.403c-0.896-0.043-2.36-0.064-4.352-0.064c-16.38,0-64.944,1.398-75.287,1.699"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M153.711,203.931c16.171-0.647,70.314-2.646,75.314-2.646h15.778"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
     M244.361,226.381c-0.082,6.945-0.438,37.594-0.438,42.388c0,1.823-0.154,7.093-0.338,13.283l-0.002,0.097
     c-0.352,12.007-0.827,28.238-0.61,33.568 M205.264,239.836c-1.533,1.381-37.696,34.033-46.034,46.072l-0.675,0.988l8.369,16.742
     l1.967-2.537c0.186-0.243,18.9-24.279,45.831-45.374l1.36-1.062l-0.834-1.513c-3.88-6.892-6.53-12.142-6.818-12.719l-1.198-2.381
     L205.264,239.836z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M293.829,53.834
     c0.29,0.207,0.581,0.41,0.874,0.613"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="296.515"
          y1="55.644"
          x2="296.523"
          y2="55.648"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.891,1.881,0.01,0"
          d="
     M296.523,55.648c0.434,0.271,0.877,0.534,1.326,0.784c2.11,1.17,4.508,1.931,6.622,2.601l0.119,0.038
     c0.766,0.246,1.557,0.499,2.299,0.761c6.379,2.24,12.767,4.64,18.987,7.133c8.591,3.44,17.162,7.171,25.474,11.088
     c0.565,0.266,1.133,0.537,1.696,0.81"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M353.051,78.865
     c0.322,0.156,0.643,0.313,0.96,0.467c-0.024,0.355-0.049,0.709-0.072,1.064"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="353.795"
          y1="82.49"
          x2="353.794"
          y2="82.502"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.828,1.818"
          d="
     M353.794,82.501c-1.34,19.633-2.815,39.834-5.718,59.824c-1.364,9.36-3.305,19.485-6.108,31.866
     c-1.209,5.357-4.029,17.848,3.041,22.727c0.38,0.26,0.784,0.487,1.213,0.679"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M346.224,197.597
     c0.32,0.144,0.654,0.268,1,0.372"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M254.722,197.865
     c-0.015-0.286-0.031-0.645-0.05-1.06"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="254.582"
          y1="194.671"
          x2="254.582"
          y2="194.659"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.86,1.849,0.01,0"
          d="
     M254.582,194.659c-0.146-3.727-0.305-9.393-0.178-14.087v-0.139l-0.002-0.044c-0.424-6.746,1.183-51.729,1.368-56.835l0.006-0.194
     L255.85,74.4"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="255.85"
          y1="74.395"
          x2="255.852"
          y2="73.327"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M292.129,46.994
     c-0.016,0.109-0.097,0.472-0.265,1.03"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="291.178"
          y1="49.978"
          x2="291.174"
          y2="49.986"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.804,1.794"
          d="
     M291.174,49.986c-1.663,4.169-5.824,11.565-14.899,15.085c-7.343,2.518-15.125,3.635-19.409,4.094"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M256.859,69.165
     c-0.381,0.04-0.736,0.076-1.059,0.107c-0.002-0.355-0.003-0.709-0.005-1.066"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="255.792"
          y1="65.916"
          x2="255.792"
          y2="65.905"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.993,1.983,0.011,0"
          d="
     M255.792,65.905c0.015-9.919,0.36-19.826,1.074-21.564c0.202-0.498,0.378-0.929,0.529-1.304"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M257.395,43.035
     c0.155-0.382,0.282-0.708,0.388-0.989c0.342-0.081,0.687-0.161,1.037-0.24"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="260.807"
          y1="41.358"
          x2="260.815"
          y2="41.356"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.773,1.763"
          d="
     M260.815,41.356c1.874-0.416,3.936-0.858,6.338-1.361c4.924-1.025,8.55-2.629,11.406-5.045c2.941-2.486,6.145-7.387,7.701-11.189"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M286.263,23.755
     c0.14-0.342,0.266-0.675,0.378-0.996"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M218.929,23.925
     c0.106,0.341,0.219,0.678,0.341,1.011"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="220.088"
          y1="26.908"
          x2="220.092"
          y2="26.919"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.858,1.848,0.01,0"
          d="
     M220.093,26.919c0.769,1.633,1.714,3.136,2.807,4.451c2.174,2.604,4.874,4.729,8.256,6.497c2.798,1.465,6.169,2.062,9.145,2.59
     l0.646,0.116c0.363,0.067,0.722,0.132,1.077,0.198l0.52,0.098c0.804,0.152,1.582,0.299,2.337,0.479"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M244.879,41.346
     c0.348,0.083,0.692,0.173,1.031,0.275c0.095,0.278,0.211,0.606,0.357,1.004"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.719,1.71"
          d="M246.916,44.496
     c0.588,2.837,0.609,13.639,0.318,23.807"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M247.234,68.312
     c-0.01,0.356-0.021,0.71-0.031,1.065c-0.322-0.049-0.673-0.104-1.051-0.166"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="244.137"
          y1="68.865"
          x2="244.127"
          y2="68.863"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.78,1.77"
          d="M244.127,68.863
     c-4.418-0.799-10.934-2.232-17.087-4.538c-10.467-4.397-13.86-14.003-14.701-17.203"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M212.338,47.116
     c-0.154-0.583-0.221-0.952-0.232-1.036"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="247.093"
          y1="73.447"
          x2="247.075"
          y2="74.514"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="247.037"
          y1="76.637"
          x2="247.037"
          y2="76.649"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.838,0.01,0"
          d="
     M247.037,76.648l-0.832,46.873c-0.151,8.347-0.91,50.32-0.91,56.995c0,5.609-0.245,12.285-0.385,15.664"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M244.91,196.18
     c-0.017,0.404-0.031,0.76-0.045,1.063"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M152.975,197.155
     c0.35-0.091,0.687-0.203,1.014-0.334"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="155.824"
          y1="195.782"
          x2="155.833"
          y2="195.775"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.84,1.83"
          d="M155.833,195.775
     c6.676-5.037,3.912-17.242,2.721-22.5c-2.817-12.454-4.755-22.579-6.103-31.865c-3.01-20.722-4.498-41.868-5.892-62.373"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M146.558,79.035
     c-0.024-0.356-0.049-0.71-0.072-1.065c0.32-0.15,0.643-0.3,0.967-0.45"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="149.383"
          y1="76.627"
          x2="149.393"
          y2="76.622"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.851,1.841,0.01,0"
          d="
     M149.393,76.622c0.85-0.39,1.703-0.777,2.549-1.153c8.446-3.742,17.096-7.275,25.714-10.496c6.202-2.323,12.628-4.569,19.104-6.679
     c0.69-0.224,1.414-0.438,2.123-0.648l0.311-0.091c2.23-0.654,4.539-1.331,6.652-2.443c1.092-0.573,2.142-1.221,3.163-1.893"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M209.009,53.22
     c0.298-0.195,0.594-0.394,0.887-0.594"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M216.425,139.667
     c-0.01,0.353-0.021,0.708-0.03,1.066"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="216.346"
          y1="142.816"
          x2="216.346"
          y2="142.825"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.813,1.803"
          d="
     M216.345,142.825c-0.409,18.797,0.223,41.713,0.497,50.262"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M216.842,193.09
     c0.013,0.383,0.024,0.739,0.035,1.063c-0.353,0.018-0.709,0.037-1.065,0.057"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="213.68"
          y1="194.319"
          x2="213.67"
          y2="194.32"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.858,1.848,0.01,0"
          d="
     M213.67,194.32c-17.19,0.891-35.983,1.723-42.898,1.746"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M170.77,196.066
     c-0.097,0.001-0.192,0.001-0.283,0.001c-0.298,0-0.558-0.002-0.781-0.006c-0.015-0.32-0.031-0.676-0.05-1.06"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="169.553"
          y1="192.918"
          x2="169.553"
          y2="192.91"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.816,1.806"
          d="
     M169.552,192.91c-0.41-7.969-1.306-23.021-1.982-29.166c-0.195-1.752-0.432-4.572-0.529-6.287
     c-0.163-2.773-0.274-5.543-0.351-7.647c-0.107-2.856-0.195-5.598-0.269-8.382c-0.073-2.488-0.133-4.971-0.188-7.461l-0.047-1.848
     c-0.017-0.668-0.036-1.349-0.047-2.029"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M166.137,130.082
     c-0.006-0.357-0.01-0.714-0.012-1.07l0.601,0.007c0.157,0,0.313-0.002,0.469-0.006"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="168.887"
          y1="128.955"
          x2="168.893"
          y2="128.955"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.473,1.465"
          d="
     M168.893,128.955c1.108-0.039,2.245-0.092,3.399-0.158"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M172.294,128.797
     c0.353-0.021,0.709-0.04,1.065-0.064"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          x1="175.97"
          y1="142.182"
          x2="178.954"
          y2="193.974"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M178.48,139.119
     c-0.298-0.164-0.611-0.334-0.938-0.511c-0.003-0.34-0.007-0.697-0.012-1.066"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="177.5"
          y1="135.302"
          x2="177.5"
          y2="135.291"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.951,1.94,0.011,0"
          d="
     M177.5,135.291c-0.015-1.012-0.032-2.063-0.05-3.099c-0.05-3.037-0.124-7.582-0.104-10.422"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M177.346,121.767
     c0.002-0.39,0.007-0.747,0.014-1.066c0.308-0.017,0.661-0.04,1.062-0.065"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="180.646"
          y1="120.498"
          x2="180.659"
          y2="120.497"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.942,1.931,0.011,0"
          d="
     M180.658,120.497c1.626-0.102,3.704-0.232,6.316-0.398c9.793-0.618,20.821-1.311,29.502-1.831"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M216.481,118.267
     c0.358-0.021,0.713-0.042,1.063-0.064c-0.03,0.325-0.061,0.677-0.092,1.059"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="217.3"
          y1="121.308"
          x2="217.3"
          y2="121.315"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.785,1.776"
          d="
     M217.299,121.315c-0.203,2.985-0.42,7.113-0.649,12.351"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M216.649,133.68
     c-0.015,0.351-0.03,0.706-0.046,1.066l-0.896,0.578"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="213.963"
          y1="136.447"
          x2="213.954"
          y2="136.453"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.805,1.795"
          d="
     M213.953,136.453l-5.721,3.686l-24.342,2.174c-0.788-0.542-2.351-1.517-5.41-3.193"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="M136.2,80.832
     l0.229,3.599c0.008,0.304,0.955,30.517,3.562,38.775c2.699,8.552,12.442,56.875,12.442,63.254c0,1.984,0.08,4.137,0.241,6.543
     c0,0-0.33,1.13-1.544,0.952"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M139.884,231.072
     c-0.336-0.112-0.672-0.225-1.007-0.342"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="136.858"
          y1="229.996"
          x2="136.848"
          y2="229.992"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.869,1.859,0.01,0"
          d="
     M136.848,229.992c-3.461-1.309-6.869-2.839-10.196-4.335l-0.15-0.067c-1.194-0.539-2.396-1.08-3.597-1.612
     c-8.634-3.812-15.429-7.502-21.386-11.618c-3.364-2.321-6.569-4.992-9.669-7.574c-2.645-2.21-5.041-4.193-7.546-6.068
     c-3.453-2.577-6.607-4.886-9.586-7.018"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M74.715,191.698
     c-0.291-0.208-0.58-0.413-0.867-0.619"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M83.107,170.91
     c0.286,0.206,0.574,0.411,0.863,0.62"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="85.675"
          y1="172.764"
          x2="85.684"
          y2="172.771"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.832,1.822"
          d="
     M85.684,172.771c2.123,1.543,4.347,3.183,6.717,4.953c2.515,1.878,4.985,3.934,7.374,5.923l0.079,0.066
     c3.146,2.621,6.4,5.332,9.889,7.737c6.167,4.262,13.174,8.073,22.049,11.991c1.191,0.526,2.381,1.058,3.57,1.596
     c3.523,1.588,7.441,3.354,11.47,4.826"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M146.836,209.865
     c0.334,0.121,0.669,0.241,1.005,0.36"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M83.496,303.639
     c-0.304-0.062-0.649-0.143-1.035-0.241"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="80.383"
          y1="302.815"
          x2="80.376"
          y2="302.813"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.879,1.869,0.01,0"
          d="
     M80.375,302.813c-9.146-2.732-29.888-10.631-44.795-16.545"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          d="M35.572,286.264
     c-0.334-0.132-0.664-0.263-0.991-0.394"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="252.762"
          y1="342.567"
          x2="252.762"
          y2="343.634"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="252.762"
          y1="345.661"
          x2="252.762"
          y2="345.673"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.765,1.755"
          x1="252.762"
          y1="345.672"
          x2="252.762"
          y2="378.284"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="252.762"
          y1="378.284"
          x2="252.762"
          y2="379.351"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="242.918"
          y1="342.567"
          x2="242.896"
          y2="343.633"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="242.854"
          y1="345.661"
          x2="242.854"
          y2="345.671"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          strokeDasharray="1.765,1.755"
          x1="242.854"
          y1="345.671"
          x2="242.181"
          y2="378.284"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.616"
          strokeMiterlimit="10"
          x1="242.181"
          y1="378.284"
          x2="242.159"
          y2="379.351"
        />
        <path
          fill="#010101"
          d="M477.516,328.954c0.334-1.22,0.159-2.485-0.043-3.569c-0.77-3.93-2.347-7.674-3.872-11.302
     c-0.859-2.049-1.758-4.18-2.48-6.288c-2.306-6.74-4.149-12.412-5.656-18.244c-3.092-11.977-8.143-23.509-13.029-34.663
     c-0.934-2.13-1.864-4.254-2.778-6.378c-6.039-13.996-12.917-30.541-18.212-47.177c-3.751-11.791-19.558-47.038-26.802-57.507
     c-7.005-10.124-16.641-26.335-19.992-34.875c-3.272-8.349-13.099-19.806-15.36-21.802l0.053-2.094l-0.043-0.127
     c-0.68-1.699-2.555-2.486-4.064-3.122c-0.319-0.134-0.621-0.261-0.903-0.394c-2.049-0.955-4.111-1.975-6.108-2.964
     c-0.489-0.239-0.983-0.484-1.47-0.723v-0.042l-0.1-0.012c-1.392-0.678-2.794-1.369-4.208-2.033
     c-8.381-3.947-16.996-7.696-25.611-11.15c-6.282-2.511-12.71-4.928-19.1-7.175c-0.818-0.286-1.673-0.557-2.496-0.822
     c-2.102-0.664-4.275-1.36-6.129-2.391c-1.811-1.004-3.554-2.273-5.243-3.5l-0.616-0.441c0.638-9.693-1.137-15.573-2.763-19.625
     c-1.2-2.986-2.341-5.922-3.171-8.992c-0.35-1.275-0.865-2.561-2.3-3.325v-0.005c-3.595-2.136-7.738-3.926-12.311-5.312
     c-7.983-2.421-16.593-2.57-24.035-2.527c-3.484,0.02-7.595,0.121-11.611,0.712c-3.569,0.514-7.165,1.529-11.313,3.191
     c-2.475,0.983-4.441,1.907-6.194,2.89l0.027,0.031c-0.584,0.165-1.259,0.754-1.269,0.76c-0.34,0.334-0.626,0.765-0.861,1.317
     c-0.26,0.611-0.393,1.243-0.526,1.848c-0.064,0.286-0.127,0.569-0.196,0.846c-0.527,1.953-1.376,3.867-2.199,5.72
     c-0.244,0.557-0.499,1.12-0.733,1.678c-1.726,4.01-3.643,9.857-3.271,19.589l-0.627,0.43c-1.705,1.185-3.473,2.406-5.301,3.367
     c-1.875,0.989-4.052,1.631-6.161,2.248c-0.828,0.239-1.683,0.493-2.507,0.765c-6.421,2.081-12.88,4.344-19.211,6.708
     c-8.685,3.257-17.385,6.805-25.862,10.56c-1.96,0.871-3.931,1.79-5.842,2.682c-2.024,0.94-4.116,1.912-6.188,2.831
     c-0.282,0.122-0.595,0.244-0.914,0.367c-1.525,0.599-3.414,1.349-4.137,3.038l-0.059,0.121v2.109
     c-2.304,1.95-12.449,13.23-15.949,21.553c-3.634,8.621-13.507,24.376-20.965,34.621c-7.541,10.377-24.352,45.534-28.437,57.331
     c-5.764,16.652-13.131,33.197-19.573,47.186c-0.983,2.125-1.971,4.25-2.969,6.379c-5.216,11.159-10.613,22.696-14.049,34.716
     c-1.674,5.859-3.686,11.557-6.188,18.314c-0.787,2.12-1.743,4.25-2.667,6.31c-1.64,3.628-3.324,7.388-4.207,11.339
     c-0.233,1.089-0.44,2.359-0.137,3.591c0.366,1.513,1.047,2.952,1.699,4.349c0.59,1.254,1.196,2.55,1.573,3.889
     c-2.178,2.778-3.362,15.264-3.585,17.852l-0.012,0.074l0.016,0.069c0.213,1.445,2.252,2.825,6.241,4.233
     c5.487,1.928,14.352,3.621,20.136,3.621c2.517,0,4.455-0.318,5.279-1.082c0.484-0.447,0.648-1.041,0.478-1.673
     c-1.137-4.155,2.815-12.918,3.835-15.063c1.036,0.27,3.469,0.79,6.969,0.79c3.782,0,4.765-1.237,6.013-2.799
     c0.382-0.484,0.78-0.982,1.301-1.507c1.482-1.477,2.412-3.634,3.23-5.535c0.112-0.255,0.223-0.511,0.323-0.75
     c1.12-2.549,2.353-5.22,3.777-8.169c2.623-5.455,5.454-10.904,8.408-16.195c2.465-4.414,5.178-8.349,8.307-12.03
     c0.095-0.116,0.377-0.472,0.765-0.976c3.097-3.988,4.939-6.173,5.476-6.481c-0.064,0.022-0.192,0.044-0.335-0.009l0.233-0.612
     l0.447,0.469c0.583-0.564,1.174-1.127,1.763-1.69c2.459-2.353,5.004-4.785,7.341-7.277c2.921-3.112,5.47-6.762,7.941-10.278
     c1.248-1.779,2.527-3.621,3.839-5.343c1.917-2.539,3.935-5.082,5.891-7.547c3.946-4.97,8.02-10.117,11.562-15.514
     c3.023-4.601,5.689-9.481,7.931-14.505c1.636-3.677,2.756-7.447,3.839-11.091c0.484-1.625,0.983-3.304,1.525-4.966
     c0.159-0.478,0.362-0.971,0.568-1.503c0.047-0.112,0.09-0.223,0.139-0.341c0.914,7.835,1.731,15.876,1.019,23.704
     c-0.653,7.187-1.258,14.501-1.837,21.57c-0.494,5.965-1.005,12.138-1.541,18.197c-0.356,4.016-0.813,8.084-1.243,12.015
     c-0.871,7.776-1.768,15.822-1.95,23.837c-0.154,6.672,0.006,13.432,0.468,20.104c0.074,1.025,0.137,2.071,0.196,3.133
     c0.329,5.413,0.664,11.007,2.267,16.036c1.142,3.585,1.77,10.405,1.77,19.186c0,2.501,0.382,3.255,2.273,4.482
     c1.705,1.104,41.206,11.711,53.247,11.711c3.931,0,9.056,0.053,14.011,0.102c10.65,0.106,20.715,0.208,22.633-0.106
     c1.126-0.192,2.226-0.319,3.261-0.394c1.067-0.079,2.056,0.028,2.964,0.143c0.925,0.124,1.876,0.277,2.837,0.447
     c1.922,0.335,12.061,0.362,22.791,0.382c4.999,0.01,10.161,0.022,14.117,0.075h0.267c12.402,0,51.759-9.949,53.485-11.022
     c1.923-1.2,2.322-1.944,2.391-4.43c0.233-8.749,1.041-15.531,2.284-19.095c1.731-4.982,2.22-10.554,2.682-15.939
     c0.096-1.057,0.187-2.099,0.286-3.119c0.638-6.639,0.978-13.375,0.999-20.019c0.032-7.988-0.654-16.02-1.312-23.78
     c-0.34-3.919-0.679-7.972-0.93-11.977c-0.377-6.049-0.722-12.206-1.057-18.159c-0.398-7.049-0.812-14.337-1.274-21.507
     c-0.499-7.806,0.531-15.806,1.652-23.592c0.047,0.111,0.09,0.229,0.128,0.341c0.202,0.531,0.387,1.029,0.531,1.507
     c0.498,1.663,0.955,3.346,1.396,4.971c0.988,3.649,2.013,7.42,3.553,11.112c2.108,5.045,4.641,9.953,7.547,14.591
     c3.399,5.428,7.336,10.622,11.149,15.642c1.885,2.48,3.83,5.045,5.677,7.6c1.259,1.737,2.497,3.59,3.699,5.385
     c2.368,3.543,4.812,7.208,7.648,10.353c2.269,2.512,4.743,4.971,7.133,7.356c0.574,0.568,1.142,1.138,1.711,1.7l0.456-0.457
     l0.218,0.617c-0.171,0.058-0.314,0.015-0.357-0.005c0.5,0.265,2.291,2.463,5.312,6.538c0.372,0.504,0.638,0.861,0.733,0.976
     c3.017,3.703,5.619,7.655,7.956,12.08c2.799,5.299,5.476,10.755,7.946,16.21c1.338,2.952,2.496,5.624,3.538,8.157
     c0.1,0.251,0.202,0.5,0.307,0.755c0.765,1.906,1.631,4.057,3.066,5.55c0.509,0.53,0.892,1.025,1.259,1.514
     c1.2,1.571,2.151,2.814,5.912,2.862c0.163,0,0.323,0.005,0.477,0.005c3.213,0,5.476-0.446,6.464-0.691
     c0.962,2.167,4.642,10.879,3.411,14.984c-0.192,0.627-0.038,1.217,0.424,1.669c0.861,0.839,2.958,1.19,5.673,1.19
     c5.599,0,13.816-1.482,19.175-3.213c6.367-2.062,6.654-3.718,6.749-4.26l0.012-0.074v-0.075c-0.159-2.561-0.998-14.931-3.092-17.74
     c0.41-1.318,1.048-2.592,1.663-3.83C476.402,331.86,477.113,330.447,477.516,328.954 M356.661,79.122
     c0.329,0.165,0.664,0.325,0.988,0.489c2.008,0.989,4.079,2.013,6.139,2.98c0.298,0.132,0.617,0.266,0.952,0.409
     c1.306,0.546,2.778,1.168,3.304,2.294l-0.053,2.125c-0.037,0.616-1.768,30.487-4.663,38.842
     c-2.911,8.408-13.874,55.977-14.038,62.287c-0.065,2.337-0.23,4.706-0.463,7.07c-0.881-0.144-1.673-0.437-2.337-0.899
     c-5.593-3.86-2.954-15.542-1.954-19.944c2.825-12.483,4.78-22.675,6.14-32.066C353.744,121.624,355.243,100.039,356.661,79.122
      M285.239,20.027c0.387,0.483,0.626,1.094,0.827,1.854c0.856,3.138,2.009,6.108,3.224,9.135c1.588,3.968,3.325,9.757,2.645,19.397
     c-0.047,0.356-1.497,10.645-15.19,15.945c-9.448,3.246-19.625,4.201-22.302,4.409c-0.069-7.181,0.016-24.172,1.152-26.944
     c0.606-1.482,0.967-2.375,1.148-2.943c3.182-0.75,6.427-1.455,10.129-2.226c4.701-0.977,8.132-2.49,10.803-4.753
     c3.07-2.598,5.364-5.95,6.623-9.699C284.76,22.837,285.079,21.44,285.239,20.027 M226.233,15.476
     c4.047-1.621,7.553-2.614,11.016-3.114c3.941-0.573,7.988-0.669,11.435-0.69c7.336-0.053,15.834,0.096,23.647,2.47
     c4.329,1.312,8.254,2.991,11.68,4.988c-0.112,1.562-0.419,3.134-0.936,4.663c-1.19,3.522-3.351,6.676-6.241,9.119
     c-2.501,2.114-5.751,3.538-10.229,4.472c-4.749,0.995-8.749,1.865-12.827,2.885c-0.064,0.015-0.164,0.037-0.292,0.058
     c-0.647,0.122-1.227,0.255-1.651,0.477c-1.063-0.382-2.136-0.743-3.176-1.088c-0.23-0.074-0.453-0.149-0.68-0.228l-0.229-0.298
     l-0.254,0.137c-0.081-0.025-0.155-0.047-0.229-0.074c-1.424-0.483-2.821-0.744-4.292-1.02l-0.456-0.09
     c-0.564-0.1-1.137-0.202-1.721-0.308c-2.933-0.515-5.965-1.057-8.403-2.331c-3.07-1.604-5.503-3.511-7.447-5.848
     c-1.683-2.024-2.973-4.579-3.723-7.394c-0.255-0.961-0.452-1.944-0.568-2.911c-0.022-0.18-0.031-0.366-0.043-0.546
     c-0.006-0.23-0.027-0.468-0.058-0.713C222.165,17.212,223.981,16.378,226.233,15.476 M214.99,29.875
     c0.233-0.553,0.483-1.105,0.728-1.663c0.849-1.901,1.715-3.861,2.263-5.912c0.079-0.297,0.148-0.601,0.213-0.896
     c0.126-0.58,0.248-1.122,0.456-1.622c0.164-0.393,0.35-0.685,0.552-0.88c0.032-0.028,0.064-0.053,0.117-0.091l0.006,0.058
     c0.006,0.214,0.021,0.431,0.043,0.643c0.132,1.03,0.334,2.066,0.605,3.086c0.802,2.99,2.177,5.72,3.983,7.893
     c2.05,2.459,4.616,4.478,7.835,6.161c2.624,1.37,5.891,1.949,8.78,2.459c0.579,0.105,1.147,0.207,1.711,0.313l0.456,0.084
     c1.429,0.273,2.778,0.522,4.117,0.973c0.053,0.022,0.101,0.031,0.154,0.053c0.155,0.563,0.494,1.476,1.074,3.033
     c1.051,2.799,0.694,20.072,0.445,27.386c-2.698-0.36-12.742-1.88-21.994-5.354c-13.481-5.652-14.665-16.057-14.691-16.359
     C211.42,39.563,213.306,33.805,214.99,29.875 M49.151,357.191c0.043,0.17,0.016,0.264-0.106,0.382
     c-1.944,1.805-15.456,0.228-24.103-2.81c-3.712-1.306-5.206-2.465-5.376-3.139c0.526-6.049,1.912-15.987,3.41-17.188
     c0.856-0.69,7.001,1.206,11.935,2.736c6.065,1.875,12.891,3.983,17.984,4.424C51.61,344.346,47.945,352.776,49.151,357.191
      M83.128,306.993c-2.963,5.311-5.81,10.786-8.449,16.263c-1.424,2.964-2.667,5.645-3.787,8.211
     c-0.106,0.244-0.218,0.499-0.329,0.753c-0.776,1.802-1.647,3.836-2.954,5.138c-0.579,0.579-1.014,1.125-1.402,1.608
     c-1.147,1.445-1.844,2.316-4.998,2.316c-3.07,0-5.306-0.424-6.384-0.679l0.09-0.192l-0.993-0.043
     c-5.004-0.222-12.243-2.464-18.627-4.434c-6.502-2.013-10.416-3.171-12.285-2.847c-0.409-1.317-0.988-2.56-1.557-3.77
     c-0.658-1.398-1.274-2.714-1.614-4.101c-0.239-0.978-0.069-2.024,0.148-3.008c0.844-3.829,2.512-7.514,4.117-11.094
     c0.934-2.077,1.901-4.228,2.704-6.384c2.284-6.167,4.158-11.462,5.746-16.795c5.625,2.236,42.783,16.965,50.947,18.41
     C83.378,306.557,83.25,306.774,83.128,306.993 M136.407,239.627c-3.51,5.338-7.568,10.464-11.499,15.413
     c-1.954,2.471-3.978,5.02-5.906,7.569c-1.323,1.743-2.614,3.596-3.867,5.386c-2.443,3.484-4.961,7.085-7.823,10.133
     c-2.316,2.465-4.844,4.887-7.293,7.23c-0.494,0.472-0.983,0.934-1.472,1.407c-0.005,0-0.01-0.005-0.021-0.005
     c-0.047,0.079-0.117,0.154-0.191,0.191c-0.049,0.016-0.091,0.043-0.134,0.069c-0.021,0.01-0.042,0.027-0.058,0.043
     c-0.01,0.006-0.022,0.015-0.027,0.015c-0.016,0.016-0.032,0.032-0.047,0.043c-0.043,0.038-0.085,0.075-0.122,0.106
     c-0.176,0.149-0.357,0.286-0.552,0.404c-0.032,0.021-0.065,0.031-0.096,0.053c0.016,0.006,0.037,0.01,0.058,0.021
     c-0.902,0.899-2.39,2.687-5.051,6.118c-0.371,0.478-0.636,0.818-0.728,0.93c-2.735,3.224-5.162,6.634-7.382,10.384
     c-5.275-0.526-35.311-12.084-51.277-18.451c0.032-0.128,0.069-0.245,0.102-0.362c2.066-7.219,4.849-14.272,7.876-21.183
     c0,0,0.006,0,0.01,0.006c0-0.006,0-0.01,0.006-0.016c0-0.01,0.006-0.021,0.006-0.031c0.042-0.096,0.079-0.186,0.132-0.276
     c0.054-0.09,0.096-0.18,0.139-0.277c0.053-0.121,0.1-0.248,0.127-0.382c0.022-0.08,0.059-0.148,0.112-0.207
     c0,0-0.005-0.005-0.01-0.005c1.816-4.102,3.708-8.154,5.582-12.159c0.998-2.129,1.991-4.259,2.969-6.383
     c6.459-14.018,13.841-30.594,19.626-47.31c0.493-1.428,1.194-3.234,2.05-5.316c3.362,2.384,6.984,5.035,11.059,8.073
     c2.554,1.901,5.035,3.972,7.441,5.975c3.144,2.623,6.395,5.333,9.857,7.723c6.103,4.213,13.035,7.983,21.825,11.866
     c1.196,0.526,2.39,1.057,3.58,1.597c4.673,2.105,9.507,4.277,14.495,5.86C138.798,235.835,137.629,237.757,136.407,239.627
      M149.553,209.368c-0.137,0.419-0.271,0.84-0.403,1.259c-0.198,0.627-0.388,1.259-0.574,1.886
     c-0.064,0.207-0.127,0.414-0.186,0.621c-0.127,0.413-0.249,0.824-0.372,1.231c-0.419,1.414-0.828,2.8-1.264,4.165
     c-0.192,0.594-0.382,1.178-0.579,1.768c-0.091,0.26-0.181,0.52-0.277,0.787c-0.095,0.281-0.196,0.563-0.301,0.843
     c-0.298,0.813-0.617,1.625-0.956,2.433c-0.133,0.314-0.266,0.623-0.404,0.936c-1.126,2.518-2.359,5.003-3.686,7.431
     c-5.008-1.567-9.89-3.766-14.612-5.885c-1.196-0.542-2.39-1.079-3.59-1.61c-8.712-3.845-15.578-7.578-21.607-11.744
     c-3.416-2.353-6.645-5.045-9.768-7.648c-2.416-2.019-4.918-4.1-7.488-6.024c-4.181-3.118-7.893-5.822-11.33-8.259
     c2.602-6.209,6.416-14.516,10.431-22.706c3.235,2.306,6.729,4.855,10.634,7.77c2.549,1.902,5.036,3.973,7.442,5.976
     c3.144,2.624,6.395,5.332,9.857,7.723c6.103,4.211,13.034,7.983,21.824,11.865c1.196,0.526,2.391,1.057,3.581,1.6
     c4.403,1.987,8.95,4.025,13.634,5.577L149.553,209.368z M151.077,204.848c-0.112,0.925-0.526,1.949-0.924,2.937
     c-0.049,0.121-0.096,0.239-0.143,0.36c-4.638-1.534-9.162-3.563-13.556-5.539c-1.189-0.542-2.389-1.079-3.59-1.61
     c-8.71-3.845-15.578-7.58-21.607-11.742c-3.41-2.353-6.644-5.047-9.767-7.649c-2.416-2.013-4.918-4.101-7.49-6.018
     c-3.988-2.979-7.541-5.571-10.84-7.915c5.454-11.058,11.181-21.728,14.696-26.562c7.495-10.299,17.444-26.169,21.108-34.88
     c3.15-7.479,11.786-17.304,14.803-20.321c0.217,6.166,1.206,30.387,3.644,38.105c2.576,8.147,12.317,56.416,12.317,62.446
     c0,6.108,0.691,12.339,1.402,18.393L151.077,204.848z M151.39,194.746c-0.217-2.777-0.366-5.546-0.366-8.285
     c0-6.331-9.693-54.336-12.375-62.84c-2.688-8.504-3.617-38.842-3.628-39.15v-2.125c0.552-1.116,2.05-1.704,3.367-2.225
     c0.341-0.134,0.664-0.261,0.962-0.393c1.492-0.655,2.974-1.344,4.445-2.024c1.429,21.076,2.927,42.836,6.013,64.092
     c1.37,9.391,3.32,19.583,6.145,32.066c0.999,4.397,3.638,16.083-1.95,19.944C153.265,194.31,152.388,194.623,151.39,194.746
      M151.885,199.94c-0.08-0.706-0.154-1.407-0.218-2.108c-0.005-0.047-0.01-0.09-0.015-0.137c-0.059-0.553-0.107-1.105-0.155-1.658
     c1.222-0.139,2.316-0.527,3.24-1.164c6.315-4.355,3.628-16.227,2.481-21.293c-2.821-12.456-4.765-22.612-6.124-31.975
     c-3.108-21.368-4.601-43.283-6.04-64.481c0.17-0.084,0.341-0.159,0.511-0.238c1.901-0.888,3.872-1.807,5.822-2.673
     c8.451-3.745,17.129-7.286,25.792-10.527c6.31-2.363,12.758-4.61,19.158-6.697c0.803-0.26,1.652-0.505,2.47-0.749
     c2.167-0.638,4.415-1.296,6.4-2.344c1.897-0.992,3.697-2.245,5.439-3.451l0.069-0.049c0.616,2.965,3.373,11.388,15.339,16.412
     c9.549,3.581,19.902,5.11,22.435,5.45l-0.908,51.084c-0.012,0.5-0.914,49.934-0.914,57.174c0,7.669-0.452,17.245-0.457,17.373
     v0.722h-17.182c-5.258,0-63.721,2.172-76.994,2.713C151.979,200.865,151.932,200.402,151.885,199.94 M152.549,205.788
     c-0.122-1.052-0.251-2.109-0.372-3.166c13.443-0.551,71.619-2.709,76.851-2.709H246.2l-0.435,23.843
     c-1.138-0.031-4.059-0.127-10.762-0.452c-8.939-0.419-72.58,1.435-80.93,1.679C154.046,218.557,153.287,212.093,152.549,205.788
      M243.48,380.491c-0.292,0.044-0.584,0.075-0.881,0.122c-1.811,0.298-12.285,0.196-22.414,0.096
     c-4.961-0.053-10.092-0.1-14.023-0.1c-11.95,0-50.702-10.395-52.546-11.506c-1.445-0.939-1.678-1.247-1.678-3.392
     c0-8.914-0.654-15.866-1.833-19.584c-1.556-4.864-1.885-10.384-2.204-15.711c-0.032-0.542-0.064-1.078-0.096-1.609
     c36.559,11.754,84.982,12.412,95.266,12.412c0.542,0,0.973,0,1.296-0.005L243.48,380.491z M244.382,339.918
     c-6.341,0.031-58.276-0.016-96.667-12.498c-0.005-0.053-0.005-0.102-0.01-0.155c-0.462-6.628-0.621-13.353-0.472-19.98
     c0.021-0.77,0.053-1.54,0.079-2.31c39.215,12.311,79.799,13.427,93.168,13.427c1.843,0,3.166-0.022,3.903-0.043V339.918z
      M244.382,317.067c-5.916,0.128-52.401,0.643-97.012-13.438c0.122-2.533,0.303-5.06,0.521-7.584
     c0.074-0.843,0.149-1.683,0.229-2.523c0.158-1.673,0.329-3.346,0.509-5.007c0.176-1.663,0.362-3.316,0.542-4.956
     c0.441-3.942,0.898-8.009,1.253-12.04c0.537-6.066,1.047-12.238,1.541-18.209c0.584-7.063,1.184-14.377,1.842-21.558
     c0.043-0.452,0.075-0.903,0.106-1.355c0.022-0.303,0.037-0.6,0.053-0.902c0.016-0.271,0.028-0.543,0.037-0.813
     c0.017-0.34,0.028-0.685,0.038-1.026c0.016-0.456,0.027-0.914,0.031-1.369c8.143-0.245,71.959-2.11,80.867-1.679
     c6.771,0.319,9.673,0.415,10.808,0.44c-0.058,5.073-0.452,38.663-0.452,43.724c0,1.817-0.148,6.895-0.338,13.321
     c-0.373,12.631-0.877,29.913-0.575,34.253V317.067z M246.645,380.184v0.006c-0.217,0.005-0.44,0.01-0.669,0.025
     c-0.388,0.028-0.791,0.069-1.195,0.112l0.882-39.129h0.016v-24.873l-0.006-0.047c-0.303-4.233,0.207-21.522,0.584-34.143
     c0.186-6.442,0.335-11.524,0.335-13.363c0-5.433,0.45-43.825,0.456-44.346l0.447-24.512h0.01v-1.991
     c0.005-0.096,0.456-9.705,0.456-17.405c0-7.224,0.908-56.647,0.918-57.152l0.914-51.664c0.043-1.142,0.897-24.868-0.499-28.596
     c-0.356-0.94-0.595-1.599-0.754-2.062c0.914,0.304,1.843,0.617,2.763,0.946L246.645,380.184z M250.661,286.331
     c-0.012,11.733-0.016,26.329-0.394,30.1l-0.037,1.429v0.027l-0.016,0.595h0.016l-0.159,22.881h0.006l-0.17,39.109
     c-0.233-0.037-0.472-0.075-0.707-0.106c-0.174-0.021-0.355-0.047-0.541-0.065c-0.181-0.02-0.362-0.042-0.553-0.057
     c-0.053,0-0.112-0.006-0.164-0.012L252.6,41.873c0.345-0.121,0.908-0.233,1.125-0.276c0.154-0.027,0.286-0.047,0.367-0.069
     c0.382-0.1,0.753-0.192,1.135-0.282c-0.18,0.463-0.44,1.126-0.834,2.083c-1.513,3.696-1.258,27.13-1.243,28.14l-0.084,51.866
     c-0.074,2.033-1.816,49.831-1.371,57.192c-0.195,7.51,0.32,17.427,0.345,18.011l-0.047,2.019l0.01-0.006l-0.196,24.023
     c-0.064,1.712-1.327,38.62-1.026,44.197C250.661,270.987,250.661,278.104,250.661,286.331 M348.599,331.956
     c-0.462,5.306-0.94,10.793-2.624,15.62c-1.731,4.983-2.214,14.346-2.354,19.487c-0.052,2.062-0.238,2.406-1.773,3.364
     c-1.827,1.066-41.525,10.951-53.05,10.83c-3.968-0.047-9.137-0.065-14.135-0.075c-10.203-0.021-20.751-0.047-22.572-0.366
     c-0.297-0.053-0.589-0.1-0.881-0.143l0.164-39.278c0.946,0.027,2.874,0.053,5.609,0.053c15.843,0,58.542-1.014,91.749-11.074
     C348.689,330.899,348.64,331.425,348.599,331.956 M349.862,306.637c0.012,0.765,0.021,1.524,0.015,2.288
     c-0.025,6.602-0.36,13.301-0.998,19.897c-0.01,0.053-0.015,0.106-0.015,0.154c-38.847,11.913-91.15,11.261-97.481,11.128
     l0.139-21.559c1.211,0.037,3.988,0.117,8.02,0.117C276.07,318.661,313.589,317.322,349.862,306.637 M346.574,255.089
     c0.335,5.953,0.68,12.11,1.057,18.165c0.251,4.021,0.602,8.079,0.936,12.009c0.558,6.554,1.125,13.295,1.274,20.029
     c-45.12,13.369-92.307,12.169-98.292,11.952l0.015-0.707c0.378-3.872,0.382-17.857,0.388-30.206
     c0.006-8.259,0.012-15.387,0.128-17.527v-0.069c-0.286-5.025,0.828-38.508,0.998-43.506c1.131-0.005,4.053-0.053,10.932-0.249
     c8.976-0.266,72.973,2.778,81.174,3.171c-0.027,1.817,0.005,3.633,0.122,5.445C345.767,240.759,346.175,248.041,346.574,255.089
      M347.248,207.759c-0.908,6.267-1.838,12.69-2.034,19.095c-8.349-0.398-72.229-3.42-81.243-3.171
     c-6.766,0.192-9.714,0.239-10.867,0.249l0.196-23.387c14.654-0.127,31.386,0.574,52.578,2.21c3.076,0.239,6.225,0.505,9.263,0.76
     c10.65,0.897,21.65,1.817,32.459,1.838C347.483,206.16,347.366,206.962,347.248,207.759 M347.78,204.061
     c-10.814-0.015-21.851-0.939-32.527-1.838c-3.044-0.26-6.192-0.52-9.279-0.759c-21.214-1.636-37.971-2.347-52.652-2.22l0.021-0.723
     v-0.025c-0.006-0.107-0.552-10.304-0.35-17.964v-0.059c-0.452-7.202,1.354-56.593,1.376-57.118l0.074-51.286
     c2.597-0.198,13.035-1.153,22.749-4.494c12.151-4.7,15.148-13.04,15.838-15.982l0.074,0.059c1.721,1.247,3.495,2.533,5.375,3.585
     c1.972,1.088,4.208,1.805,6.369,2.49c0.818,0.26,1.663,0.531,2.459,0.813c6.374,2.235,12.78,4.641,19.041,7.149
     c8.6,3.448,17.193,7.186,25.549,11.122c1.172,0.552,2.341,1.12,3.51,1.695c-1.435,21.055-2.928,42.805-6.012,64.018
     c-1.361,9.358-3.305,19.514-6.124,31.97c-1.147,5.066-3.836,16.938,2.48,21.293c0.844,0.584,1.832,0.951,2.937,1.116
     C348.429,199.298,348.115,201.689,347.78,204.061 M349.591,209.799c-0.372-0.993-0.759-2.019-0.855-2.937h-0.043
     c0.866-6.012,1.727-12.2,1.886-18.281c0.159-6.002,11.186-53.837,13.974-61.895c2.64-7.611,4.264-31.688,4.647-37.817
     c2.933,3.07,11.298,13.051,14.246,20.556c3.432,8.742,12.928,24.73,20.131,35.141c3.373,4.87,8.796,15.583,13.931,26.673
     c-3.351,2.263-6.957,4.769-10.994,7.638c-2.619,1.859-5.169,3.876-7.628,5.826c-3.181,2.528-6.474,5.137-9.937,7.414
     c-6.129,4.021-13.087,7.602-21.893,11.255c-1.212,0.499-2.422,1.019-3.628,1.529c-4.44,1.886-9.025,3.819-13.703,5.253
     C349.682,210.038,349.635,209.921,349.591,209.799 M355.046,227.347c-1.504-3.611-2.471-7.174-3.489-10.951
     c-0.446-1.636-0.903-3.32-1.408-5.004c-0.005,0-0.005-0.005-0.005-0.01c4.732-1.455,9.326-3.399,13.783-5.284
     c1.209-0.515,2.415-1.026,3.627-1.529c8.881-3.687,15.903-7.304,22.106-11.373c3.511-2.304,6.825-4.933,10.028-7.473
     c2.455-1.937,4.982-3.946,7.574-5.788c3.963-2.816,7.505-5.275,10.793-7.501c3.782,8.217,7.351,16.53,9.779,22.739
     c-3.485,2.353-7.246,4.967-11.485,7.983c-2.623,1.864-5.161,3.879-7.62,5.838c-3.182,2.523-6.475,5.135-9.934,7.414
     c-6.124,4.031-13.077,7.612-21.871,11.271c-1.212,0.509-2.422,1.019-3.634,1.541c-4.769,2.024-9.708,4.121-14.755,5.592
     C357.272,232.367,356.103,229.876,355.046,227.347 M405.786,297.325c-0.09-0.115-0.34-0.45-0.697-0.933
     c-2.523-3.399-3.956-5.206-4.837-6.13c-0.124-0.059-0.234-0.133-0.31-0.223c-0.084-0.118-0.185-0.223-0.286-0.323
     c-0.006,0-0.01-0.006-0.015-0.006c-0.075-0.043-0.144-0.096-0.208-0.143c-0.143-0.081-0.266-0.181-0.362-0.304
     c-0.009,0.006-0.015,0.006-0.025,0.012c-0.474-0.478-0.946-0.946-1.424-1.418c-2.374-2.369-4.839-4.818-7.085-7.309
     c-2.773-3.069-5.19-6.697-7.537-10.203c-1.201-1.805-2.443-3.671-3.717-5.417c-1.861-2.571-3.814-5.142-5.7-7.633
     c-3.792-4.992-7.718-10.161-11.079-15.546c-1.178-1.876-2.3-3.813-3.351-5.774c5.029-1.487,9.921-3.559,14.644-5.566
     c1.204-0.514,2.415-1.025,3.626-1.529c8.877-3.697,15.893-7.319,22.085-11.388c3.511-2.31,6.825-4.939,10.028-7.484
     c2.449-1.944,4.977-3.957,7.563-5.795c4.127-2.937,7.808-5.497,11.212-7.803c0.797,2.088,1.439,3.889,1.895,5.318
     c5.312,16.687,12.213,33.274,18.256,47.292c0.919,2.13,1.855,4.26,2.784,6.389c1.752,4,3.526,8.047,5.221,12.148h-0.01
     c0.106,0.165,0.18,0.345,0.217,0.537v0.005c0.006,0.012,0.01,0.021,0.016,0.032v-0.032c0,0.015,0.006,0.037,0.01,0.059
     c0.08,0.154,0.149,0.319,0.214,0.478c0.015,0.043,0.025,0.084,0.042,0.121h0.006c2.82,6.895,5.391,13.933,7.25,21.118
     c0.031,0.118,0.064,0.233,0.095,0.356c-16.024,6.066-46.167,17.077-51.44,17.522C410.752,303.996,408.426,300.566,405.786,297.325
      M475.844,354.794c-0.107,0.341-0.834,1.563-5.853,3.182c-8.749,2.826-21.73,4.111-23.546,2.332
     c-0.112-0.112-0.137-0.202-0.084-0.367c1.312-4.366-2.109-12.784-3.309-15.525c5.066-0.371,11.902-2.369,17.968-4.148
     c4.934-1.439,11.074-3.245,11.903-2.549C474.372,338.929,475.482,348.792,475.844,354.794 M472.917,336.38
     c-1.853-0.351-5.763,0.739-12.259,2.645c-6.321,1.849-13.469,3.941-18.441,4.137c-0.016,0.006-0.031,0.006-0.049,0.012
     c-0.016,0.01-0.037,0.02-0.053,0.025c-0.106,0.022-0.213,0.038-0.313,0.053c-0.096,0.022-0.196,0.043-0.291,0.053
     c-0.124,0.028-0.239,0.053-0.363,0.09c-0.037,0.012-0.068,0.012-0.095,0.006c-1.11,0.245-3.298,0.616-6.273,0.579
     c-3.134-0.047-3.792-0.918-4.897-2.358c-0.377-0.494-0.796-1.046-1.355-1.625c-1.258-1.312-2.077-3.342-2.799-5.135
     c-0.099-0.255-0.207-0.511-0.307-0.761c-1.047-2.555-2.21-5.237-3.559-8.206c-2.481-5.475-5.168-10.957-7.977-16.28
     c-0.124-0.217-0.24-0.435-0.357-0.647c8.143-1.308,45.434-15.341,51.112-17.481c1.433,5.311,3.15,10.586,5.253,16.72
     c0.737,2.158,1.641,4.303,2.517,6.379c1.498,3.565,3.044,7.245,3.782,11.048c0.198,0.977,0.335,2.018,0.069,2.973
     c-0.366,1.377-1.02,2.673-1.705,4.047C473.963,333.847,473.352,335.079,472.917,336.38"
        />
      </g>
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.616"
        strokeMiterlimit="10"
        x1="-528.45"
        y1="271.958"
        x2="-527.633"
        y2="272.48"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.616"
        strokeMiterlimit="10"
        x1="-532.383"
        y1="281.601"
        x2="-533.204"
        y2="281.087"
      />
    </svg>
  );
}
